// services/api.js
import axios from 'axios';
import store from '../vuex';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
const call = axios.create({
	baseURL: API_BASE_URL,
	timeout: 10000,
	headers: {
		'Content-Type': 'application/json',
	},
});

// Request interceptor → attach token dynamically
call.interceptors.request.use(
	(config) => {
		const token = store.getters['auth/getAuthToken'];
		if (token) {
			config.headers['accessToken'] = token; // ✅ custom header
		}
		return config;
	},
	(error) => Promise.reject(error),
);

// Response interceptor → handle 401
call.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response && error.response.status === 403) {
			store.dispatch('auth/logout'); // clear auth
			window.location.href = '/insurance/auth'; // redirect to login
		}
		return Promise.reject(error);
	},
);

export default call;
